import React from 'react'
import { Link, withRouter } from 'react-router-dom'

import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import { AgGridReact } from 'ag-grid-react'
import { Button, Icon } from 'antd'
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.css'
import 'primereact/resources/themes/lara-light-indigo/theme.css'
import { Toolbar } from 'primereact/toolbar'

import AddNewButton from '../../components/CustomButtons/addNewButton'
import ExportButton from '../../components/CustomButtons/exportGreenButton'
import GlobalSearchInput from '../../components/CustomGlobalSearchInput/globalSearchInput'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

class ListMember extends React.Component {
  constructor(props) {
    super(props)
    this.gridApi = null
    this.gridColumnApi = null

    this.state = {
      columnDefs: [
        { headerName: 'Nome', field: 'name', width: 30, filter: 'agTextColumnFilter' },
        { headerName: 'Email', field: 'emailAddress', width: 30, filter: 'agTextColumnFilter' },
        { headerName: 'Time', field: 'organization_names', width: 20, filter: 'agTextColumnFilter' },
        { headerName: 'Regional', field: 'region_names', width: 20, filter: 'agTextColumnFilter' },
        { headerName: 'Distrito', field: 'district_names', width: 30, filter: 'agTextColumnFilter' },
        { headerName: 'Perfil', field: 'profile_name', width: 20, filter: 'agTextColumnFilter' },
        {
          headerName: 'Status do Usuário',
          field: 'active',
          width: 20,
          filter: 'agTextColumnFilter',
          valueFormatter: (params) => (params.value ? 'Ativo' : 'Inativo'),
          cellStyle: {
            display: 'flex',
            justifyContent: 'center'
          }
        },
        {
          headerName: 'Editar',
          field: 'id',
          width: 10,
          sortable: false,
          resizable: false,
          cellRenderer: this.actionCellRenderer
        }
      ],
      defaultColDef: {
        sortable: true,
        resizable: true,
        minWidth: 1,
        width: 100,
        floatingFilter: true
      },
      rowData: []
    }
  }

  goToCreateMember() {
    const { history } = this.props
    history.push('/member/create')
  }

  async listMembers(params) {
    try {
      const data = await request(api.listMembers({ ...params }))
      return data
    } catch (error) {
      console.error('Error getting members:', error)
      return []
    }
  }

  onGridReady = (params) => {
    this.gridApi = params.api
    this.gridColumnApi = params.columnApi

    this.gridApi.sizeColumnsToFit()

    this.listMembers().then((data = []) => {
      const formattedData = data.map(({ districts, regions, organizations, user, ...rest }) => ({
        ...rest,
        organization_names: (organizations || []).map(({ name }) => name).join(', '),
        region_names: (regions || []).map(({ name }) => name).join(', '),
        district_names: (districts || []).map(({ name }) => name).join(', '),
        profile_name: user?.profile?.name || ''
      }))

      this.setState({ rowData: formattedData })
    })
  }

  renderHeader() {
    const leftContents = (
      <h2>
        <b>Profissionais</b>
      </h2>
    )

    const rightContents = (
      <div className="container-header-lists">
        <GlobalSearchInput
          value={this.state.value3}
          onChange={(e) => this.gridApi?.setGridOption('quickFilterText', e.target.value)}
        />

        <div>
          <ExportButton iconType="excel" label={getMessage('label.exportXls')} onClick={() => this.onBtnExport()} />
          <AddNewButton label={getMessage('addMember')} onClick={() => this.goToCreateMember()} />
        </div>
      </div>
    )

    return <Toolbar start={leftContents} end={rightContents} />
  }

  render() {
    return (
      <>
        {this.renderHeader()}
        <div style={{ width: '100%', height: '70vh' }} className="ag-theme-alpine">
          <AgGridReact
            columnDefs={this.state.columnDefs}
            defaultColDef={this.state.defaultColDef}
            onGridReady={this.onGridReady}
            rowData={this.state.rowData}
            rowSelection="single"
            getRowStyle={(params) => ({
              color: params.data && params.data.active ? 'inherit' : 'gray'
            })}
          />
        </div>
      </>
    )
  }

  onBtnExport = () => {
    if (this.gridApi) {
      this.gridApi.exportDataAsCsv()
    }
  }

  actionCellRenderer(params) {
    return (
      <Link to={`/member/${params.value}`}>
        <Button
          type="ghost"
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', border: 'none' }}
        >
          <Icon type="edit" size="small" />
        </Button>
      </Link>
    )
  }
}

export default withRouter(ListMember)
